import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { publicProjectsQuery, siteSettingsQuery } from "@/lib/query-registry";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import type { PublicProject } from "@/components/site/WorkContent";

export const Route = createFileRoute("/work")({
  head: () => buildHead({
    locale: "en",
    title: "Shopify Case Studies: Decisions, Delivery and Outcomes · Shugert",
    description: "Selected Shopify case studies documenting the starting constraint, intervention, evidence, limits, and related commercial entry, not just screenshots.",
    path: "/work",
    altPath: alternatePath("/work", "es"),
    jsonLd: breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Work", path: "/work" }]),
  }),
  loader: async ({ context }) => {
    await setEdgeHtmlCache();
    const [{ projects }, { settings }] = await Promise.all([
      context.queryClient.ensureQueryData(publicProjectsQuery()),
      context.queryClient.ensureQueryData(siteSettingsQuery()),
    ]);
    return {
      projects: projects as PublicProject[],
      workLimit: settings.work_projects_limit,
    };
  },
});
